export default "/cloudly.bad38b33-fc4644.svg";